import React, { useEffect, useState, useMemo, useRef } from 'react'
import Navigation from '../../Components/Navigation'
import No from '../../Assets/Images/Login/no.svg'
import Modal from '@mui/material/Modal'
import Box from '@mui/material/Box'
import './generarCotizacion.css'
import NoImage from '../../Assets/Images/Logos/no-image.png'
import { useSelector, useDispatch } from 'react-redux'
import {
  addComment,
  guardarCotizacion,
  mostrarDescuento,
  addChannel,
} from '../../redux/actions/cotizacionActions.js'
import { searchSalesDocumentDetailService } from 'redux/services/cotizacionServices'
import { BoxArrowUp } from 'react-bootstrap-icons'
import { useParams, useHistory } from 'react-router-dom'
import FilteringTable from '../../Components/FilteringTable'
import {
  FormatedDate,
  updateHiddenColumns,
  validateRoles,
  validatorErrorUpdate,
  validatorIsCountedCustomer,
  sanitizeOrderNumber,
} from 'Utils/functions'
import { Formatter } from 'Utils/Formatter'
import GenericModal from 'Components/GenericModal'
import ConfirmStartSalesOrder from 'Components/SalesOrder/ConfirmStartSalesOrder'
import GenerateSalesOrder from 'Components/SalesOrder/GenerateSalesOrder'
import {
  creditAccountsAction,
  getChannelsAction,
} from 'redux/actions/catalogActions'
import { ID_CONSTANTS } from 'redux/types'
import {
  CUSTOMERID,
  documentTypeId,
  salesOrderTypeIds,
  VAPermissions,
  EMPTY_GUID,
} from 'Utils/constants'
import { generateSellOrderAction } from 'redux/actions/sellOrderActions'
import MarginText from 'Components/MarginText/MarginText'
import { t } from 'i18next'
import ModalAlertCart from 'Components/ModalAlertCart/ModalAlertCart'
import { useUploadOdcFile } from 'Views/OrdenDeVenta/hooks/useUploadOdcFile'
import aa from 'search-insights'
import ModalAlertGeneric from 'Components/ModalAlertGeneric/ModalAlertGeneric'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import ToolTipAmount from 'Components/ToolTipAmount/ToolTipAmount'
import { updateProductsAuth } from 'Utils/salesOrdersUtil'
import useHandlePermission from 'Hooks/useValidatePermission'
import DeliveryDateLabel from 'Components/DeliveryDateLabel/DeliveryDateLabel'
import { useCotizationLogic } from 'Views/VentaPorProducto/hooks/useCotizationLogic'
import { updateSellerIfApplicable } from 'Utils/Helpers/updateSellerIfApplicable'
import { setServiceNote } from 'redux/actions/cotizacionActions'
import { getValidServiceNote } from 'Utils/Helpers/getValidServiceNote'
import { QuotationPdfOptions } from 'Views/GenerarCotizacion/components/QuotationPdfOptions/QuotationPdfOptions'
import { AdditionalServiceDetailsEditor } from 'Views/GenerarCotizacion/components/AdditionalServiceDetailsEditor/AdditionalServiceDetailsEditor'
import Tints from 'Hooks/useTintsController/Tints'
import { useMarginVisibility } from 'Hooks/useMarginVisibility'
import { getMarginColumn } from 'Components/FilteringTable/columns/MarginColumn'

aa('init', {
  appId: 'ZCZRBTYD8I',
  apiKey: '6c9235a951666253b5b003e1cf34d9ce',
})

function SubtotalText() {
  const showDiscountOption = useSelector(
    state => state.cotizacion.QuoteHeader.ShowDiscountOption
  )

  return (
    <div className="money-data-text">
      <p>Sub Total</p>
      <p
        style={{
          display: showDiscountOption ? 'block' : 'none',
        }}>
        Descuento
      </p>
      <p>ITBMS</p>
      <p>Total</p>
    </div>
  )
}

function SubtotalNumbers({ setDiscount }) {
  const channelRef = useRef(null)
  if (!channelRef.current) {
    channelRef.current = new BroadcastChannel('customer_display')
  }
  const channel = channelRef.current

  const useSelectorProductos = useSelector(
    state => state.cotizacion.QuoteHeader.Lines
  )

  const useSelectorDetalle = useSelector(state => state.cotizacion.QuoteHeader)
  const showDiscountOption = useSelector(
    state => state.cotizacion.QuoteHeader.ShowDiscountOption
  )
  const [subtotal, setSubTotal] = useState(0)
  const [subtotalWithDiscount, setSubtotalWithDiscount] = useState(0)
  const [totalDiscountAmount, setTotalDiscountAmount] = useState(0)

  const calcSubtotal = () => {
    let subtotal = 0
    let subtotalWithDiscount = 0
    let DiscountAmount = 0
    useSelectorProductos.forEach(item => {
      const finalPrice =
        item.Price > item.BasePrice ? item.Price : item.BasePrice

      DiscountAmount +=
        Number(
          Formatter.Money(item.DiscountAmount, {
            withFormat: false,
          })
        ) * item.Quantity
      DiscountAmount = Number(
        Formatter.Money(DiscountAmount, {
          withFormat: false,
        })
      )

      const subtotalLine = Number(
        Formatter.Money(item.Price * item.Quantity, {
          withFormat: false,
          decimalPrecision: 2,
          rounded: true,
        })
      )
      subtotal = Number(
        Formatter.Money(subtotalLine + subtotal, {
          withFormat: false,
        })
      )

      subtotalWithDiscount = Number(
        Formatter.Money(finalPrice * item.Quantity + subtotalWithDiscount, {
          withFormat: false,
          decimalPrecision: 2,
          rounded: true,
        })
      )
    })

    setSubTotal(
      Number(
        Formatter.Money(subtotal, {
          withFormat: false,
          decimalPrecision: 2,
          rounded: true,
        })
      )
    )
    setSubtotalWithDiscount(
      Number(
        Formatter.Money(subtotalWithDiscount, {
          withFormat: false,
        })
      )
    )
    setDiscount(
      Number(
        Formatter.Money(DiscountAmount, {
          withFormat: false,
          decimalPrecision: 2,
        })
      )
    )
    setTotalDiscountAmount(
      Number(
        Formatter.Money(DiscountAmount, {
          withFormat: false,
          decimalPrecision: 2,
        })
      )
    )

    const subTotalWithDiscountConvert = Number(
      Formatter.Money(subtotalWithDiscount, {
        withFormat: false,
      })
    )

    const subTotalConvert = Number(
      Formatter.Money(subtotal, {
        withFormat: false,
        decimalPrecision: 2,
        rounded: true,
      })
    )

    const discountAmountConvert = Number(
      Formatter.Money(DiscountAmount, {
        withFormat: false,
        decimalPrecision: 2,
      })
    )

    const validationDiscount = showDiscountOption
      ? subTotalWithDiscountConvert
      : subTotalConvert

    useSelectorDetalle.SubTotal = validationDiscount
    useSelectorDetalle.DiscountAmount = discountAmountConvert

    channel.postMessage({
      isDetailQuote: true,
      quoteData: useSelectorDetalle,
      isLoadingDetailQuote: false,
      showDiscount: showDiscountOption,
    })
  }

  useEffect(() => {
    calcSubtotal()
  }, [useSelectorProductos, showDiscountOption])

  return (
    <div className="money-data-totals">
      <p>
        $
        {showDiscountOption
          ? Formatter.Money(subtotalWithDiscount, {
              decimalPrecision: 2,
              rounded: true,
            })
          : Formatter.Money(subtotal, {
              decimalPrecision: 2,
              rounded: true,
            })}
      </p>
      <p
        style={{
          display: showDiscountOption ? 'block' : 'none',
        }}>
        ${Formatter.Money(totalDiscountAmount)}
      </p>
      <ToolTipAmount amount={useSelectorDetalle?.Tax} isMargin />
      <ToolTipAmount amount={subtotal + useSelectorDetalle?.Tax} isMargin />
    </div>
  )
}

function GenerarCotizacion(props) {
  const quillRef = useRef(null)
  const { uploadFile } = useUploadOdcFile()
  const [comment, setComment] = useState('')
  const [discount, setDiscount] = useState(0)
  const { Channel } = useSelector(state => state.cotizacion.QuoteHeader)
  const { sellOrderPostData } = useSelector(state => state.sellOrder)
  const existingCreditAccount =
    sellOrderPostData?.Data?.SalesDocumentInfo?.CreditAccountId &&
    sellOrderPostData.Data.SalesDocumentInfo.CreditAccountId !== EMPTY_GUID
      ? {
          CreditAccountId:
            sellOrderPostData.Data.SalesDocumentInfo.CreditAccountId,
          CreditAccountNumber:
            sellOrderPostData.Data.SalesDocumentInfo.CreditAccountNumber,
          Description:
            sellOrderPostData.Data.SalesDocumentInfo.CreditAccountNumber,
        }
      : null
  const [open, setOpen] = useState(false)
  const [hasRelationDocs, setHasRelationDocs] = useState(false)
  const [showChangesODVAlert, setShowChangesODVAlert] = useState(false)
  const [showModalConfirmStartSalesOrder, setShowModalConfirmStartSalesOrder] =
    useState(false)
  const [confirmStartSalesOrder, setConfirmStartSalesOrder] = useState(false)
  const [showModalGenerateSalesOrder, setShowModalGenerateSalesOrder] =
    useState(false)
  const useSelectorQuoteObject = useSelector(state => state.cotizacion)
  const [directdeliveryState] = useState(false)
  // const { isCommercialCreditSelected } = useSelector(state => state.sellOrder);
  const [showFailedSellOrderState, setShowFailedSellOrderState] =
    useState(false)
  const promisedDate = useSelectorQuoteObject?.QuoteHeader?.PromisedDate
  const [isErrorAddressModal, setIsErrorAddressModal] = useState(false)
  const [messageAddressModal, setMessageAddressModal] = useState({
    message: '',
    status: '',
  })
  const [isLoadingCreateQuote, setIsLoadingCreateQuote] = useState(false)
  const history = useHistory()

  const param = useParams()
  const user = useSelector(state => state.login.user)
  const useSelectorProductos = useSelector(
    state => state.cotizacion.QuoteHeader.Lines
  )
  const { isInstallationService } = useCotizationLogic()

  const prodWithNoCost = useSelectorProductos.filter(item => {
    const isService = item.IsService
    const isInstallation = isInstallationService(item)
    const hasNoCost = item.Cost === 0

    return !isService && !isInstallation && hasNoCost
  })

  const hasProdWithNoCost = useSelectorProductos.some(item => {
    const isService = item.IsService
    const isInstallation = isInstallationService(item)
    const hasNoCost = item.Cost === 0

    return !isService && !isInstallation && hasNoCost
  })

  const [createOdv, setCreateOdv] = useState(false)
  const company = useSelector(state => state.company)

  const canChangePriceODV = useHandlePermission(
    VAPermissions.priceOverrideAuthODV
  )

  const useSelectorDetalle = useSelector(state => state.cotizacion.QuoteHeader)

  const useEstadoGuardar = useSelector(state => state.cotizacion)

  const showDiscountOption = useSelector(
    state => state.cotizacion.QuoteHeader.ShowDiscountOption
  )
  const algoliaIndex = useSelector(
    state => state?.login?.checkCompany?.[0].InitialCatalog
  )

  const fulfillmentPlan =
    (useSelectorDetalle.Lines || []).filter(
      item => item.FulfillmentPlanDescription
    )?.[0]?.FulfillmentPlanDescription ?? null

  const [channelList, setChannelList] = useState([])
  const isDistributionSeller = validateRoles(
    user?.AuthenticationInfo?.UserRoles,
    'Vendedor Comercial Distribución'
  )

  const isConstructionSeller = validateRoles(
    user?.AuthenticationInfo?.UserRoles,
    'Vendedor Comercial Construcción'
  )

  const viewProductMargin = useHandlePermission(VAPermissions.seeMargenProd)
  const { showAll, toggleAll, toggleRow, isRowVisible } = useMarginVisibility(
    useSelectorProductos.length
  )

  // columnas ocultas
  const [hiddenColumns, setHiddenColumns] = useState([])
  const columns = useMemo(() => {
    const baseColumns = [
      {
        Header: 'Referencia',
        accessor: 'Referencia',
        Footer: <MarginText />,
        hideEnabled: true,
      },
      {
        Header: 'Número de Parte',
        accessor: 'Número de Parte',
        hideEnabled: true,
      },
      {
        Header: 'Descripción',
        accessor: 'Descripción',
      },
      {
        Header: 'Imagen',
        accessor: 'Imagen',
        hideEnabled: true,
      },
      {
        Header: 'Marca',
        accessor: 'Marca',
        hideEnabled: true,
      },
      {
        Header: 'País de Origen',
        accessor: 'País de Origen',
        hideEnabled: true,
      },
      {
        Header: 'Cantidad',
        accessor: 'Cantidad',
      },
      {
        Header: 'Precio Unitario',
        accessor: 'Precio Unitario',
        Footer: <SubtotalText />,
      },
      {
        Header: 'Descuento',
        accessor: 'Descuento',
        hideEnabled: true,
      },
      {
        Header: 'Precio Total',
        accessor: 'Precio Total',
        Footer: <SubtotalText />,
      },
    ]

    if (viewProductMargin) {
      baseColumns.push(
        getMarginColumn({
          showAll,
          toggleAll,
          toggleRow,
          isRowVisible,
          footer: <SubtotalNumbers setDiscount={setDiscount} />,
        })
      )
    }

    return baseColumns
  }, [viewProductMargin, showAll, isRowVisible])

  const dispatch = useDispatch()

  const Hoy = new Date()
  const dd = String(Hoy.getDate()).padStart(2, '0')
  const mm = String(Hoy.getMonth() + 1).padStart(2, '0') // January is 0!
  const yyyy = Hoy.getFullYear()
  const Fecha = yyyy + '-' + mm + '-' + dd

  const setTableData = data => {
    const products = data.map(product => {
      return {
        ...product,
        Referencia: product?.Sku,
        Descripción: (
          <>
            <div>{product?.ProductName}</div>
            {product?.ColorVariants && (
              <Tints key={product?.ProductId} tints={product?.ColorVariants} />
            )}
          </>
        ),
        Imagen:
          (product.Images && product.Images[0].URL) ||
          product.DefaultProductPicture ||
          NoImage,
        Marca: product?.Brand,
        'País de Origen': 'Panamá',
        Cantidad: product?.Quantity,
        'Precio Unitario':
          !showDiscountOption || product?.Price > product?.BasePrice
            ? product?.Price === null
              ? 0
              : product?.Price
            : product?.BasePrice,
        Descuento: product?.DiscountAmount,
        'Precio Total': product?.Price * product?.Quantity,
        'Número de Parte': product?.ManufacturerPartNumber || 'Desconocido',
      }
    })
    return products
  }

  const productsData = useMemo(
    () => setTableData(useSelectorProductos),
    [showDiscountOption]
  )

  const hasOdv = useEstadoGuardar?.QuoteHeader?.RelationDoc?.find(
    doc =>
      doc?.DocumentNumber?.includes('ODV') ||
      doc?.DocumentTypeId?.toLowerCase()?.includes(
        documentTypeId?.ODV?.toLowerCase()
      )
  )

  const fetchChannel = async () => {
    const Data = await dispatch(getChannelsAction())
    if (Data && Data?.length > 0 && Data?.[0]?.ChannelId) {
      setChannelList(Data)
    }
  }

  const handleOpen = () => {
    setOpen(true)
  }

  const updateQuote = (updatedQuote, action) => {
    dispatch(
      guardarCotizacion(
        updatedQuote,
        props,
        setIsErrorAddressModal,
        setMessageAddressModal,
        setIsLoadingCreateQuote,
        action
      )
    )
  }
  const saveCotizacion = async () => {
    if (comment === null || comment === undefined) {
      setComment('')
      dispatch(addComment(''))
      useEstadoGuardar.QuoteHeader.Comment = ''
    } else {
      useEstadoGuardar.QuoteHeader.Comment = comment
      dispatch(addComment(comment))
    }
    const newColumns = []
    const newHiddenColumns = hiddenColumns.map(column => {
      return column.ColumnName
    })
    const columnsVisible = updateHiddenColumns(newHiddenColumns, columns)

    const partNumberColumn = columnsVisible.find(
      column => column.ColumnName === 'Número de Parte'
    )

    const ShowPartNumber = partNumberColumn?.Status || false

    // eslint-disable-next-line array-callback-return
    columnsVisible.map(column => {
      newColumns.push({
        ...column,
        DocumentId: useEstadoGuardar.QuoteHeader.QuoteHeaderId,
      })
    })
    if (newColumns.length > 0) {
      useEstadoGuardar.Columns = newColumns
    }

    useEstadoGuardar.QuoteHeader.ServiceNote = getValidServiceNote(quillRef)
    useEstadoGuardar.QuoteHeader.ShowPartNumber = ShowPartNumber

    // Dispatch to Redux for persistence
    dispatch(setServiceNote(useEstadoGuardar.QuoteHeader.ServiceNote))

    useEstadoGuardar.QuoteHeader = {
      ...useEstadoGuardar.QuoteHeader,
      Telephone: validatorIsCountedCustomer(useEstadoGuardar?.QuoteHeader)
        ? useEstadoGuardar.QuoteHeader.Telephone
        : undefined,
      Lines: useEstadoGuardar.QuoteHeader.Lines.map((linea, index) => ({
        ...linea,
        LineNum: index + 1,
        Amount: Number(
          Formatter.Money(linea.Amount, {
            withFormat: false,
          })
        ),
        AmountWithTax: Number(
          Formatter.Money(linea.AmountWithTax, {
            withFormat: false,
          })
        ),
        Tax: Number(
          Formatter.Money(linea.Tax, {
            withFormat: false,
          })
        ),
      })),
      CustomerId: useEstadoGuardar?.QuoteHeader?.CustomerId,
      Discount: discount,
      CompanyId: company.CompanyId,
      CompanyCode: company?.CompanyCode,
      WarehouseId: useSelectorQuoteObject?.QuoteHeader?.WarehouseId,
      WarehouseDescription:
        useSelectorQuoteObject?.QuoteHeader?.WarehouseDescription,
      WarehouseAddress: useSelectorQuoteObject?.QuoteHeader?.WarehouseAddress,
      WarehouseCode: useSelectorQuoteObject?.QuoteHeader?.WarehouseCode,
      WarehouseName: useSelectorQuoteObject?.QuoteHeader?.WarehouseName,
      SalesAgentId:
        useSelectorDetalle?.SalesAgentId || user?.AuthenticationInfo?.UserId,
      AddressId: useSelectorDetalle?.Address_AddressId,
      PromisedDate: promisedDate,
    }

    dispatch({
      type: 'SET_IS_REDIRECT',
      payload: true,
    })

    const updatedQuote = updateSellerIfApplicable(
      useEstadoGuardar,
      user.AuthenticationInfo.UserRoles,
      user.CustomerInfo
    )

    const action = 'editionPage'
    if (hasOdv) {
      setIsLoadingCreateQuote(true)

      const response = await validatorErrorUpdate(
        hasOdv,
        useEstadoGuardar,
        user,
        setIsErrorAddressModal,
        setMessageAddressModal,
        props,
        updatedQuote,
        action
      )

      if (response) return
      updateQuote(updatedQuote, action)
    }
    updateQuote(updatedQuote, action)
  }

  const noChannel = () => {
    saveCotizacion()
  }

  const handleClose = () => {
    setOpen(false)
  }

  const getSkusNoCostProduct = () => {
    const inactiveCodes = prodWithNoCost.map(product => product.Sku)

    const skusProd = inactiveCodes.join(', ')
    return skusProd
  }

  useEffect(() => {
    setComment(useSelectorDetalle.Comment)
    setHasRelationDocs(
      useSelectorDetalle?.RelationDoc &&
        useSelectorDetalle?.RelationDoc.length > 0
    )
  }, [])

  useEffect(() => {
    fetchChannel()
  }, [])

  const fetchODV = async () => {
    const odvDocHeaderId = useSelectorDetalle?.RelationDoc?.find(
      doc =>
        doc.DocumentNumber.includes('ODV') ||
        doc?.DocumentTypeId?.toLowerCase().includes(
          documentTypeId?.ODV?.toLowerCase()
        )
    )?.DocHeaderId
    const response = await searchSalesDocumentDetailService({
      DocumentTypeId: documentTypeId.ODV,
      DocumentHeaderId: odvDocHeaderId,
      DocumentNumber: null,
      PageNumber: 1,
      PageSize: 1,
    })
    const dataFormated = {
      Data: { SalesDocumentInfo: { ...response?.data?.Data } },
    }
    dispatch({ type: 'SELL_ORDER_POST_RESULT', payload: dataFormated })
  }

  const handleModalConfirmStartSalesOrder = () => {
    setShowModalConfirmStartSalesOrder(!showModalConfirmStartSalesOrder)
    !sellOrderPostData && fetchODV()
  }

  const processSalesOrder = async values => {
    dispatch({ type: 'SELL_ORDER_FILE_ATTACHED', payload: values.file })
    dispatch({ type: 'IS_COMMERCIAL_CREDIT_SELECTED', payload: values })
    await generateODV(values)
  }

  const generateODV = async values => {
    const isCreditCommercial = values?.credit === 'yes'
    const creditAccountId = values?.accountItemSelected?.CreditAccountId
    const hasValidCreditAccount =
      isCreditCommercial && creditAccountId && creditAccountId !== EMPTY_GUID

    if (
      existingCreditAccount &&
      hasValidCreditAccount &&
      creditAccountId !== existingCreditAccount.CreditAccountId
    ) {
      setShowModalGenerateSalesOrder(false)
      setMessageAddressModal({
        message: t('GENERATE_SALES_ORDER_T.CREDIT_ACCOUNT_LOCKED'),
        status: 'error',
      })
      setIsErrorAddressModal(true)
      return
    }

    if (isCreditCommercial && !hasValidCreditAccount) {
      setShowModalGenerateSalesOrder(false)
      setMessageAddressModal({
        message: t('GENERATE_SALES_ORDER_T.INVALID_CREDIT_ACCOUNT'),
        status: 'error',
      })
      setIsErrorAddressModal(true)
      return
    }

    const customerId = useSelectorQuoteObject?.QuoteHeader?.CustomerId
    const ServiceNote = getValidServiceNote(quillRef)
    console.log(
      'hasValidCreditAccount ? sanitizeOrderNumber(values?.orderNumber)',
      hasValidCreditAccount ? sanitizeOrderNumber(values?.orderNumber) : 'null'
    )

    const payload = {
      documentTypeId: ID_CONSTANTS.salesOrder.sellOrderTypeID,
      salesOrder: {
        PromisedDate: promisedDate,
        addressId: useSelectorDetalle?.Address_AddressId,
        customerId: customerId || CUSTOMERID,
        CustomerEmail: useSelectorQuoteObject?.QuoteHeader?.EmailAddress,
        ...(validatorIsCountedCustomer(useSelectorQuoteObject?.QuoteHeader) && {
          Telephone: useSelectorQuoteObject?.QuoteHeader?.Telephone,
        }),
        customerNameDocument:
          useSelectorQuoteObject?.QuoteHeader?.CustomerNameDocument,
        creditAccountId: hasValidCreditAccount ? creditAccountId : null,
        salesAgentId: useSelectorQuoteObject?.QuoteHeader?.SalesAgentId,
        DocumentDate: useSelectorQuoteObject?.QuoteHeader?.DocumentDate,
        quantity: useSelectorQuoteObject?.QuoteHeader?.Quantity,
        amount: useSelectorQuoteObject?.QuoteHeader?.Amount,
        amountWithTax: useSelectorQuoteObject?.QuoteHeader?.AmountWithTax,
        tax: useSelectorQuoteObject?.QuoteHeader?.Tax,
        cost: useSelectorQuoteObject?.QuoteHeader?.Cost,
        companyId: useSelectorQuoteObject?.QuoteHeader?.CompanyId,
        companyCode: useSelectorQuoteObject?.QuoteHeader?.CompanyCode,
        quoteHeaderId: useSelectorQuoteObject?.QuoteHeader?.QuoteHeaderId,
        salesOrderTypeId:
          values?.credit === 'yes'
            ? salesOrderTypeIds.credito_comercial
            : salesOrderTypeIds.pago_contado,
        HeaderStatusId: ID_CONSTANTS.salesOrder.headerStatusSalesOrderID,
        isDirectDelivery: directdeliveryState ? 1 : 0,
        salesOrderStatusId: ID_CONSTANTS.salesOrder.salesOrderStatusID,
        comments: comment,
        salesAgentEmail: null,
        lines: populateItemsArrayOfPayload(),
        warehouseId: useSelectorQuoteObject?.QuoteHeader?.WarehouseId,
        warehouseCode: useSelectorQuoteObject?.QuoteHeader?.WarehouseCode,
        origin: useSelectorQuoteObject?.QuoteHeader?.Origin || 'VA',
        ...(sellOrderPostData?.Data?.SalesDocumentInfo?.DocHeaderId && {
          SalesOrderHeaderId:
            sellOrderPostData?.Data?.SalesDocumentInfo?.DocHeaderId,
        }),
        ...(sellOrderPostData?.Data?.SalesDocumentInfo?.DocumentNumber && {
          DocumentNumber:
            sellOrderPostData?.Data?.SalesDocumentInfo?.DocumentNumber,
        }),
        Channel,
        CreditAccountId: hasValidCreditAccount ? creditAccountId : null,
        CreditAccountNumber: hasValidCreditAccount
          ? values?.accountItemSelected?.CreditAccountNumber
          : null,
        OrderNumber: hasValidCreditAccount
          ? sanitizeOrderNumber(values?.orderNumber)
          : null,
        ServiceNote,
        IsCatalog: useSelectorQuoteObject?.QuoteHeader?.IsCatalog || false,
        IsService: useSelectorQuoteObject?.QuoteHeader?.IsService || false,
      },
    }

    const result = await dispatch(generateSellOrderAction(payload))
    if (result.message !== 'ERROR') {
      if (values.file) {
        await uploadFile({
          file: values.file,
          docData: result.Data.SalesDocumentInfo,
        })
      }

      if (canChangePriceODV && result.Data) {
        const needsPriceApproval = result.Data.SalesDocumentInfo?.Lines?.some(
          line => line.Price < line.FinalPrice && !line.AuthorizedPriceBy
        )
        if (needsPriceApproval) {
          const variables = {
            saleOrderDocHeaderId: result?.Data?.SalesDocumentInfo?.DocHeaderId,
            saleOrderDocumentNumber:
              result?.Data?.SalesDocumentInfo.DocumentNumber,
            user: user?.AuthenticationInfo,
          }
          await updateProductsAuth(variables)
        }
      }
      dispatch({
        type: 'SET_PREORDER_VALIDATION',
        payload: true,
      })

      dispatch({
        type: 'SET_IS_DIRECT_DELIVERY',
        payload: directdeliveryState,
      })

      dispatch({
        type: 'SET_IS_REDIRECT',
        payload: false,
      })

      dispatch({ type: 'CLEAN_COMMERCIAL_CREDIT_SELECTED' })

      const route = `/orden_de_venta/created/${result.Data.SalesDocumentInfo?.DocHeaderId}`
      history.push(route)
    } else {
      setShowFailedSellOrderState(true)
    }
  }

  // AQUI TENGO QUE MODIFICAR
  const populateItemsArrayOfPayload = () => {
    const arrayOfItems = []

    useSelectorQuoteObject?.QuoteHeader?.Lines.forEach((lineItem, i) => {
      const payloadFormation = {
        ...(sellOrderPostData?.Data?.SalesDocumentInfo?.Lines && {
          SalesOrderLineId:
            sellOrderPostData?.Data?.SalesDocumentInfo?.Lines?.find(
              prod =>
                prod.ProductId?.toLowerCase() ===
                lineItem?.ProductId?.toLowerCase()
            )?.DocLineId || '00000000-0000-0000-0000-000000000000',
        }),
        productId: lineItem?.ProductId,
        priceListId: lineItem?.PriceListId,
        warehouseId: useSelectorQuoteObject?.QuoteHeader?.WarehouseId,
        quantity: lineItem?.Quantity,
        amount: lineItem?.Amount,
        amountWithTax: lineItem?.AmountWithTax,
        BasePrice: lineItem?.BasePrice,
        DiscountAmount: lineItem?.DiscountAmount,
        FinalPrice: lineItem?.FinalPrice,
        tax: lineItem?.Tax,
        cost: lineItem?.Cost,
        price: lineItem?.Price,
        lineNum: i + 1,
        qtyOrdered: lineItem?.Quantity,
        qtyDelivered: 0,
        qtyCanceled: 0,
        qtyOutstanding: 0,
        isDirectDelivery: lineItem?.IsDirectDelivery,
        ...(lineItem?.Price < lineItem?.FinalPrice && {
          NegotiatedPriceBy: lineItem.NegotiatedPriceBy,
          NegotiatedPriceByName: lineItem.NegotiatedPriceByName,
        }),
        ColorVariants: lineItem?.ColorVariants,
        FulfillmentPlanId: lineItem?.FulfillmentPlanId,
        FulfillmentPlanDescription: lineItem?.FulfillmentPlanDescription,
      }

      const cleanEntries = Object.fromEntries(
        Object.entries(payloadFormation).filter(([_, v]) => v != null)
      )

      arrayOfItems.push(cleanEntries)
    })

    return arrayOfItems
  }
  const generateSalesOrder = () => {
    dispatch({
      type: 'CLEAN_SELL_ORDER',
      payload: null,
    })
    handleModalConfirmStartSalesOrder()
  }

  useMemo(() => {
    setCreateOdv(param?.type_document === 'sales_order')

    if (param?.type_document === 'sales_order') {
      dispatch(
        creditAccountsAction({
          customerId: useSelectorDetalle?.CustomerId,
          companyId: useSelectorDetalle?.CompanyId,
        })
      )
    }
  }, [])

  const handleAddPurchaseOrder = () => {
    const lines = useSelectorProductos

    aa('purchasedObjectIDsAfterSearch', {
      userToken: aa('getUserToken'),
      eventName: 'ADD_PURCHASE_ORDER',
      index: algoliaIndex,
      objectIDs: lines.flatMap(({ objectID }) => objectID || []),
      objectData: lines.map(({ queryID, FinalPrice, Discount, Quantity }) => ({
        queryID,
        Price: FinalPrice,
        discount: Discount || 0,
        Quantity,
      })),
      value: lines
        .reduce((total, { FinalPrice, TaxCategoryValue, Quantity }) => {
          // Calcular el total por línea considerando FinalPrice, Taxes y Quantity
          const totalLine =
            (FinalPrice + FinalPrice * (TaxCategoryValue || 0)) * Quantity
          return total + totalLine
        }, 0)
        .toFixed(2),
      currency: 'USD',
    })
  }

  const checkRelationDocs = () => {
    handleAddPurchaseOrder()
    if (createOdv) {
      generateSalesOrder()
    } else {
      if (hasRelationDocs) {
        setShowChangesODVAlert(hasRelationDocs)
      } else {
        setShowChangesODVAlert(false)
        Channel ? noChannel() : handleOpen()
      }
    }
  }

  const handleModalGenerateSalesOrder = () => {
    setShowModalGenerateSalesOrder(!showModalGenerateSalesOrder)
  }

  useEffect(() => {
    if (confirmStartSalesOrder) {
      setConfirmStartSalesOrder(false)
      handleModalGenerateSalesOrder()
    }
  }, [confirmStartSalesOrder])

  const hiddenColumnDiscount = bool => {
    if (bool !== showDiscountOption) {
      dispatch(mostrarDescuento(bool))
    }
  }

  const getArrayHiddenColumns = hiddenColumns => {
    const hiddenColumnsCopy = hiddenColumns.filter(column =>
      column.Status === false ? column.ColumnName : false
    )
    return hiddenColumnsCopy.map(column => column.ColumnName)
  }

  useEffect(() => {
    if (isConstructionSeller) {
      return dispatch(addChannel('Ventas a clientes – Construcción'))
    } else if (isDistributionSeller) {
      return dispatch(addChannel('Ventas a clientes – Distribución'))
    }
  }, [isConstructionSeller, isDistributionSeller])

  return (
    <>
      <Navigation />
      <ModalAlertCart preQuote={true} shopping={false} saleProduct={false} />
      <div className="cotizacion-generada-container">
        <div className="cotizacion-generada">
          <h2 className="titulo-cotizacion">Detalle de cotización</h2>
          <p className="alert-document">
            Verifica que los datos en la cotización creada sean los correctos
          </p>
          <div className="info-general">
            <div className="info-general-cliente">
              <p>Cliente: {useSelectorDetalle.CustomerNameDocument}</p>
              <p>
                Email:{' '}
                {useSelectorDetalle.EmailAddress ||
                  useSelectorDetalle.CustomerEmail ||
                  'Sin información'}
              </p>
              <p>
                Teléfono:{' '}
                {useSelectorDetalle.Telephone ||
                  useSelectorDetalle.Telephone_Number ||
                  'Sin información'}
              </p>
            </div>
            <div className="info-general-retiro">
              {useSelectorDetalle?.Address_AddressId ? (
                <>
                  <p>Envío a domicilio</p>
                  <p>
                    {t('Address', {
                      value:
                        useSelectorDetalle?.Origin === 'AB'
                          ? useSelectorDetalle?.QuoteAddressStreet ||
                            useSelectorDetalle?.QuoteAddressDetail ||
                            t('whithoutDatail')
                          : useSelectorDetalle?.Address_Street ||
                            useSelectorDetalle?.QuoteAddressStreet ||
                            t('whithoutDatail'),
                    })}
                  </p>
                  <p>
                    {`${useSelectorDetalle.Address_DistrictName}, ${useSelectorDetalle.Address_CountryName}`}
                  </p>
                  <p>
                    {t('Alias', {
                      value:
                        useSelectorDetalle?.Origin === 'AB'
                          ? useSelectorDetalle?.Address_AddressName ||
                            useSelectorDetalle?.Name ||
                            t('whithoutDatail')
                          : useSelectorDetalle.Address_AddressDetail ||
                            useSelectorDetalle.QuoteAddressDetail ||
                            t('whithoutDatail'),
                    })}
                  </p>
                  <p>
                    {t('Phone', {
                      value:
                        useSelectorDetalle?.Address_Telephone_Number ||
                        t('whithoutDatail'),
                    })}
                  </p>
                  <DeliveryDateLabel date={promisedDate} variant="delivery" />
                </>
              ) : (
                <>
                  <p>Retiro en sucursal</p>
                  <p>{useSelectorDetalle.WarehouseAddress}</p>
                  <p>{useSelectorDetalle.WarehouseDescription}</p>
                  <p>{useSelectorDetalle.WarehouseCode}</p>
                  <DeliveryDateLabel date={promisedDate} variant="pickup" />
                </>
              )}
              {fulfillmentPlan && <p>Plan de entrega: {fulfillmentPlan}</p>}
            </div>
            <div className="info-general-vendedor">
              <p>Vendedor: {useSelectorDetalle.SalesAgentFullName}</p>
              <p>Fecha: {FormatedDate(Fecha)}</p>
            </div>
          </div>
          <QuotationPdfOptions />
          {hasProdWithNoCost ? (
            <div className="sell-order-product-advice">
              <p>
                <span className="info-advice-text-title">Nota: </span>
                No se puede generar una cotización con productos de costo cero (
                {getSkusNoCostProduct()}). Por favor, revisa los costos con
                compras antes de continuar.
              </p>
            </div>
          ) : null}
          <FilteringTable
            data={productsData}
            prodWithNoCost={prodWithNoCost}
            columns={columns}
            // showMargin={showAll}
            isProductPage={true}
            setHiddenColumns={columns => setHiddenColumns(columns)}
            hiddenColumns={getArrayHiddenColumns(hiddenColumns)}
            hiddenColumnDiscount={bool => {
              hiddenColumnDiscount(bool)
            }}
            showDiscountOption={showDiscountOption}
          />
        </div>
        <AdditionalServiceDetailsEditor ref={quillRef} />
        <div className="cotizacion-generada-documento">
          <div>
            <h2 style={{ fontSize: '16px' }}>Adjuntar documento</h2>
            <div className="adjuntar">
              <label htmlFor="cotizacion-file-upload">
                <BoxArrowUp /> Examinar
              </label>
              <input id="cotizacion-file-upload" type="file" />
            </div>
          </div>
          <div>
            <h2 style={{ fontSize: '16px' }}>Agregar comentario</h2>
            <textarea
              value={comment || ''}
              onChange={e => setComment(e.target.value)}
              maxLength={5000}
            />
          </div>
        </div>
        <div className="cotizacion-save-button">
          <button
            onClick={() => checkRelationDocs()}
            className="guardar_button">
            {isLoadingCreateQuote ? (
              <FontAwesomeIcon icon={faSpinner} className="spinner" />
            ) : createOdv ? (
              'Guardar orden de venta'
            ) : (
              'Guardar'
            )}
          </button>
        </div>
        <Modal
          open={showChangesODVAlert}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description">
          <Box>
            <GenericModal
              hideCheck={true}
              showCaution={false}
              setConfirm={() => {
                setShowChangesODVAlert(false)
                Channel ? noChannel() : handleOpen()
              }}
              setIsOpen={() => setShowChangesODVAlert(false)}
              text={
                '¿Estás seguro que deseas aplicar los cambios en la cotización?'
              }
              text2={'Estos cambios actualizarán la orden de venta generada'}
              mostrarButtons={true}
              closeLessPadding={true}
              gapTexts={true}></GenericModal>
          </Box>
        </Modal>
        <Modal
          open={showFailedSellOrderState}
          onClose={() => {
            setShowFailedSellOrderState(false)
          }}>
          <Box>
            <GenericModal
              hideCheck={true}
              showCaution={true}
              setConfirm={() => {}}
              setIsOpen={() => setShowFailedSellOrderState(false)}
              text={'No se ha podido crear la orden de venta'}
              mostrarButtons={false}></GenericModal>
          </Box>
        </Modal>
        {/* Modal confirmar iniciar orden de venta */}
        <Modal open={showModalConfirmStartSalesOrder}>
          <Box>
            <ConfirmStartSalesOrder
              setShowModalConfirmStartSalesOrder={
                handleModalConfirmStartSalesOrder
              }
              setConfirmStartSalesOrder={setConfirmStartSalesOrder}
              processSalesOrder={processSalesOrder}
            />
          </Box>
        </Modal>
        {/* Modal generar orden de venta */}
        <Modal open={showModalGenerateSalesOrder}>
          <Box>
            <GenerateSalesOrder
              setShowModalGenerateSalesOrder={handleModalGenerateSalesOrder}
              processSalesOrder={processSalesOrder}
              originalCreditAccount={existingCreditAccount}
            />
          </Box>
        </Modal>
        <Modal
          open={open}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description">
          <Box className="modal-box-channel">
            <div className="closing-button">
              <img src={No} onClick={handleClose} alt="close" />
            </div>
            <div className="modal-box-channel-content">
              <div className="modal-box-channel-heading">
                <h2>Selecciona el canal por donde entró la solicitud</h2>
              </div>
              <ul className="modal-box-channels">
                {channelList?.map(({ ChannelId, Channel }) => (
                  <li key={ChannelId}>
                    <input
                      type="radio"
                      name="canal"
                      id={Channel}
                      value={Channel}
                      onClick={({ target }) => {
                        dispatch(addChannel(target.value))
                      }}
                    />
                    <label htmlFor={Channel}>{Channel}</label>
                  </li>
                ))}
              </ul>
              <button
                onClick={() => {
                  handleClose()
                  saveCotizacion()
                }}>
                Continuar
              </button>
            </div>
          </Box>
        </Modal>
        <ModalAlertGeneric
          isError={isErrorAddressModal}
          setIsError={setIsErrorAddressModal}
          messageSettings={messageAddressModal}
          setMessageSettings={setMessageAddressModal}
        />
      </div>
    </>
  )
}

export default GenerarCotizacion
